var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05901 1.37409C5.36678 0.790752 6.20223 0.790752 6.51 1.37409L7.53206 3.31126C7.65075 3.53622 7.86708 3.6934 8.11771 3.73676L10.2759 4.11018C10.9258 4.22263 11.184 5.01718 10.7243 5.49016L9.19776 7.06082C9.02049 7.24321 8.93786 7.49752 8.97406 7.74928L9.28584 9.91724C9.37972 10.5701 8.70384 11.0611 8.11196 10.7701L6.14645 9.80366C5.9182 9.69143 5.65081 9.69143 5.42256 9.80366L3.45705 10.7701C2.86517 11.0611 2.18929 10.5701 2.28317 9.91724L2.59495 7.74928C2.63115 7.49752 2.54852 7.24321 2.37125 7.06082L0.844724 5.49016C0.385043 5.01718 0.643209 4.22263 1.29311 4.11018L3.4513 3.73676C3.70193 3.6934 3.91826 3.53622 4.03695 3.31126L5.05901 1.37409Z",
    fill: "#FEFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.0c4e40c110ffb247137c5e60ef69940b.svg";
export { ForwardRef as ReactComponent };